import {ContentType} from "@components/CustomTypography/Content/Content"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CompanyVisionCard.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
	className?: string
} & ContentType

const CompanyVisionCard = (props: Props) => {
	return (
		<div className={`${styles.cardBox} ${props.className}`}>
			<Typography
				className={styles.title}
				content={props.data.title}
				variant={Variant.Title}
			/>
			<Separator size={16} />
			<Typography
				content={props.data.content}
				size={Size.S}
				variant={Variant.Description}
			/>
		</div>
	)
}

export default CompanyVisionCard
